import { useState } from 'react';

import SignIn from './SignIn.jsx';
import ForgotPassword from './ForgotPassword.jsx';

// Unauthenticated entry point. Toggles between sign-in and forgot-password
// INITIATION. Web v1 has no sign-up and no reset-code entry — those live on the
// Halo mobile app and the /password-code bridge.
export default function AuthScreen() {
  const [view, setView] = useState('signIn');
  // Becomes true after the first toggle, so focus only moves to a heading on a
  // deliberate view change — not on the initial gate render. (ForgotPassword
  // always mounts via a toggle, so it manages its own focus internally.)
  const [toggled, setToggled] = useState(false);

  const goTo = (next) => {
    setToggled(true);
    setView(next);
  };

  if (view === 'forgot') {
    return <ForgotPassword onBackToSignIn={() => goTo('signIn')} />;
  }
  return (
    <SignIn
      autoFocusHeading={toggled}
      onForgotPassword={() => goTo('forgot')}
    />
  );
}
